import React from 'react';
import styles from './FilterPanel.module.css';

interface FilterChipProps {
  label: string;
  isSelected?: boolean;
  onClick?: () => void;
}

export const FilterChip: React.FC<FilterChipProps> = ({ label, isSelected = false, onClick }) => (
  <button className={`${styles.filterChip} ${isSelected ? styles.filterChipSelected : ''}`} onClick={onClick}>
    {label}
  </button>
);
